import React, { Component } from 'react'
import { connect } from 'react-redux';
import styled from 'styled-components';
import { CartItem } from './';
import axios from 'axios';
import _ from 'lodash';
import { numberWithDelimiter } from '../utils';
import {  Gutter, ButtonA, ButtonAPrice, PrimaryButton, ButtonAWhite, FinalButtonArea } from '../stylesheets/components'
import media from '../stylesheets/media';
import { onApplyDiscount } from '../actions';


const CartContainer = styled.div`
  border:1px solid ${props => props.bwMode === "black" ? "white" : "black"};

  /* div, p, a{
    color: ${props => props.bwMode === "black" ? "white" : "black"};
  } */

  div.title {
    color: ${props => props.bwMode === "black" ? "white" : "black"};
  }
`;

const Fragment = React.Fragment;
const Header = styled.div`

  display: flex;
  border-bottom: 1px solid ${props => props.bwMode === "black" ? "white" : "black"};


  div.title {
    width: 40%;
  }
  div.licenses {
    width: 50%;


  }

`;


const TotalArea = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.bwMode === "black" ? "white" : "black"};
  padding-top: 10px;
  margin-top: 10px;


  div {
    color: ${props => props.bwMode === "black" ? "white" : "black"};
  }
`;


const Disclaimer = styled.div`
  margin: 20px 0;
  color: #828282;
  font-size:0.8em;
  line-height: 1.2;
`;

const Empty = styled.p`
  padding: 20px;
`;

const DiscountValidation = styled.div`
background: #fff !important;
  color: #fff;
  padding: 10px 15px;
  margin: 20px 0;
  p{
     font-size: 0.8em;
     color: #000 !important;
  }
}`;

const DiscountArea = styled.div`
  border: 1px solid ${props => props.bwMode === "black" ? "white" : "black"};
  padding: 10px 15px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background: ${props => props.bwMode === "black"? "black" : "white"};
  color: ${props => props.bwMode === "black"? "white" : "black"};
  
  .title {
    font-size: 0.8em;
    color: ${props => props.bwMode === "black" ? "white" : "black"};
    width: fit-content;
    width: -moz-fit-content;
  }
  
  .discount-code {
    display: flex;
    align-items: center;
    justify-content: space-between;

    input {
      flex: 1;
      padding: 8px;
      margin-right: 10px;
      border: transparent;
      background: transparent;
      color: ${props => props.bwMode === "black" ? "white" : "black"};
    }
    
    button {
      background: transparent;
      color: ${props => props.bwMode === "black" ? "white" : "black"};
      border: none;
      cursor: pointer;
    }
  }
`;

const DiscountCode = styled.div`
  border: 1px solid red;
  padding: 10px 15px;
  margin: 20px 0;
  p{
     font-size: 0.8em;
     color: red;
  }
}`;

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDiscountError: false,
      showDiscountSuccess: false,
      discountCode: '',
      errorMessage: '',
      discountedPrice: 0,
      totalAmount: 0,
      couponInput: this.props.cart.coupon_code || ''
    };
  }

  handleUpdateCoupon(code) {

    if (code === "" ) {
      window.alert("Please enter a valid discount code");
    } else {
        let params = {
          code: code
        };
        
        axios.post(`/api/apply/coupon`, params).then((response) => {
          if (response.data.success) {
            this.props.dispatch(onApplyDiscount(response.data));
            this.setState({
              showDiscountSuccess: true,
              showDiscountError: false,
              discountCode: code,
              discountedPrice: response.data.discount_price,
              totalAmount: response.data.discounted_amount
            });
          }
          else {
            this.setState({
              showDiscountError: true,
              showDiscountSuccess: false,
              discountCode: code,
              discountedPrice: response.data.discount_price,
              totalAmount: response.data.discounted_amount,
              errorMessage: `The discount code ${code} has expired or is not valid.`
            });
            console.log("Please enter a valid discount code");
          }
        });

    }
  }

  render() {
    let { cart, checkoutButton, bwMode } = this.props;
    const { showDiscountError, showDiscountSuccess, couponInput, errorMessage, discountedPrice, totalAmount } = this.state;
    console.log(cart);
    return (
      <Fragment>
        <h3>
          Your font licenses:
        </h3>
        {showDiscountError && (
          <DiscountCode bwMode={bwMode}>
            <p>{errorMessage}</p>
          </DiscountCode>
        )}
        {(cart.cart_items.length > 0) && 
          showDiscountSuccess && (
            <DiscountValidation bwMode={bwMode}>
              <p className='title'>Discount code successfully applied!</p>
            </DiscountValidation>
          )
        }
        <Gutter h={15} />
        <CartContainer bwMode={bwMode}>

          {
            cart.cart_items.length > 0 ?
            <Fragment>

              {
                _.map(cart.cart_items, item => {
                  return (
                    <CartItem 
                      {...item} 
                      editable={this.props.editable} 
                      licenses={this.props.licenses} 
                      key={item.id}
                      handleUpdateCoupon={(code) => this.handleUpdateCoupon(code)}
                      discountInput={couponInput}
                      showDiscountSuccess={showDiscountSuccess}
                    />
                  )
                })
              }

            </Fragment> :
            <Empty>
              Cart is Empty.
            </Empty>
          }

        </CartContainer>
        {(cart.cart_items.length > 0 ) &&(
        <DiscountArea bwMode={bwMode}>
          <h2 className='title'>Discount Code</h2>
          <div className='discount-code'>
            <input 
              type="text" 
              placeholder="Enter code" 
              ref={(input) => { this.discountInput = input; }}
              value={couponInput || cart.coupon_code || ''}
              onChange={(e) => this.setState({ couponInput: e.target.value })}
              name='couponInput'
            />
            <button onClick={() => this.handleUpdateCoupon(couponInput)}>Apply</button>
          </div>
        </DiscountArea>
        )}
        <Disclaimer>
All licenses (desktop, web and app) require a one-time payment for perpetual use, with no recurring fees. Web fonts require a single payment, which is based on the number of unique visitors per month. If the number of monthly unique visitors exceeds the terms of your license, we ask that you upgrade to the appropriate license. Thanks, from the UT team.        </Disclaimer>
{(cart.cart_items.length > 0) && (
  (showDiscountSuccess || (cart.coupon_code && !showDiscountError)) && (
    <TotalArea bwMode={bwMode}>
      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
        <img 
          src="/assets/delete_cart_btn.svg" 
          alt="delete" 
          onClick={() => this.handleUpdateCoupon("Enter Code")}
        />
        <div>
          {couponInput || cart.coupon_code}
        </div>
      </div>
      
      <div className="delete-price">
        <div className="price">
          -${discountedPrice || cart.discounted_amount}
        </div>
      </div>
    </TotalArea>
  )
)}
        <TotalArea bwMode={bwMode}>

          <div>
            Total Amount
          </div>
          <div>
           ${(showDiscountSuccess || showDiscountError) ? totalAmount : numberWithDelimiter(cart.total)}
          </div>
        </TotalArea>
        <Gutter h={20} />
        {
          cart.isCheckoutable && checkoutButton ?
            <FinalButtonArea>
              <ButtonAPrice bwMode={bwMode}>
              ${(showDiscountSuccess || showDiscountError) ? totalAmount : numberWithDelimiter(cart.total)}
              </ButtonAPrice>
              <ButtonAWhite bwMode={bwMode} href="/order/new">Checkout</ButtonAWhite>
            </FinalButtonArea> : null
        }
      </Fragment>
    )
  }
}

let mapStateToProps = state => {
  return {
    cart: state.cart,
    bwMode: state.bwMode
  }
}

export default connect(mapStateToProps)(Cart);
